/* eslint-disable jsx-a11y/iframe-has-title */
import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './App'
import reduxStore from './reduxStore'

const formScript = document.getElementById(process.env.SCRIPT_TAG_ID!)!

const clientId = formScript.dataset.clientId
const formType = formScript.dataset.formType
const formName = formScript.dataset.formName
const employmentStatus = formScript.dataset.employmentStatus

if (process.env.APP_ENV === 'development') {
  const { worker } = require('~/common/mocks/browser')
  worker.start()
}

ReactDOM.render(
  <StrictMode>
    <Provider store={reduxStore}>
      <>
        <App
          clientId={clientId}
          formType={formType}
          formName={formName}
          employmentStatus={employmentStatus}
        />
        <iframe
          src='https://worker.mei-kyu.com/storage-bridge.html'
          style={{ display: 'none' }}
          id='iframe'
        ></iframe>
      </>
    </Provider>
  </StrictMode>,
  document.getElementById('recruit_form')
)
